import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import '../AssetsSidebar/AssetsSidebar.css';

// ─── Pole Design Sidebar Definitions ──────────────────────────────────────────
const POLE_DESIGN_ITEMS = [
    { label: 'Design Components', view: 'design-components', matchKeys: ['Design Components', 'design-components', 'Components', 'components'] },
    { label: 'Pole Designs', view: 'pole-designs', matchKeys: ['Pole Designs', 'pole-designs', 'Pole Design', 'pole-design'] },
];

/**
 * PoleDesignSidebar
 *
 * Props:
 *   setView    {function}  — app-level navigation callback
 *   activeItem {string}    — current active tab/page ('Design Components' | 'Pole Designs')
 */
const PoleDesignSidebar = ({ setView, activeItem, onSubItemClick }) => {
    const [isOpen, setIsOpen] = useState(true);

    const isItemActive = (item) => {
        if (!activeItem) return false;
        if (activeItem === item.label || activeItem === item.view) return true;
        if (item.matchKeys && item.matchKeys.includes(activeItem)) return true;
        return false;
    };

    return (
        <div className="assets-sidebar">
            <div className="assets-sidebar-section-wrap">
                <div
                    className="assets-sidebar-section-title"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <span>Pole Designs</span>
                    <ChevronDown
                        size={12}
                        className={`assets-sidebar-chevron${isOpen ? ' open' : ''}`}
                    />
                </div>

                {isOpen && (
                    <div className="assets-sidebar-items-list">
                        {POLE_DESIGN_ITEMS.map((item) => {
                            const active = isItemActive(item);
                            return (
                                <div
                                    key={item.label}
                                    className={`assets-sidebar-sub-item${active ? ' active' : ''}`}
                                    onClick={() => {
                                        if (onSubItemClick) onSubItemClick(item.label);
                                        setView && setView(item.view);
                                    }}
                                >
                                    {item.label}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PoleDesignSidebar;
